module.exports = __webpack_public_path__ + "img/nbus_container_4_title.080f000e.jpg";